export default "__VITE_ASSET__d8a6b0fe__"